import React from 'react';

import {
  useGlobalController,
  RootStateContext,
  RootStateDispatchContext,
  useOpenableController,
  ModalContext,
  ThemeContext,
  useThemeController,
} from '@/controllers';
import { FCC } from '@/utils/types';

const GlobalProvider: FCC = ({ children }) => {
  const [state, dispatch] = useGlobalController();
  const modalController = useOpenableController();
  const themeController = useThemeController();
  return (
    <RootStateDispatchContext.Provider value={dispatch}>
      <RootStateContext.Provider value={state}>
        <ModalContext.Provider value={modalController}>
          <ThemeContext.Provider value={themeController}>{children}</ThemeContext.Provider>
        </ModalContext.Provider>
      </RootStateContext.Provider>
    </RootStateDispatchContext.Provider>
  );
};

export default GlobalProvider;
